import { ReactNode } from "react";

import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";
import Button from "ds/components/Button";

import { TemplateContext } from "../Context";
import TemplateFeatureGateTooltip from "../../TemplatesWorkbench/FeatureGate/Tooltip";
import { TemplateActions } from "../../TemplatesWorkbench/FeatureGate/types";

type TemplateVersionsPageLayoutProps = {
  children?: ReactNode;
  onCreate?: () => void;
};

const TemplateVersionsPageLayout = ({ children, onCreate }: TemplateVersionsPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);
  const { template } = useTypedContext(TemplateContext);

  useTitle(`Template Versions · ${accountName}`);

  return (
    <>
      <PageInfoHeader title="Versions">
        <PageInfoHeaderActions>
          <TemplateFeatureGateTooltip
            action={TemplateActions.EditTemplate}
            template={template}
            on={({ isDisabled, ...props }) => (
              <Button {...props} variant="primary" onPress={onCreate} disabled={isDisabled}>
                Create version
              </Button>
            )}
          />
        </PageInfoHeaderActions>
      </PageInfoHeader>

      {children}
    </>
  );
};

export default TemplateVersionsPageLayout;
